/*!
 * devextreme-angular
 * Version: 16.2.5
 * Build date: Tue Feb 28 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var nested_option_1 = require('../../core/nested-option');
var nested_option_2 = require('../../core/nested-option');
var DxoMyComponent = (function (_super) {
    __extends(DxoMyComponent, _super);
    function DxoMyComponent(parentOptionHost, optionHost) {
        _super.call(this);
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    Object.defineProperty(DxoMyComponent.prototype, "x", {
        get: function () {
            return this._getOption('x');
        },
        set: function (value) {
            this._setOption('x', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoMyComponent.prototype, "y", {
        get: function () {
            return this._getOption('y');
        },
        set: function (value) {
            this._setOption('y', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoMyComponent.prototype, "_optionPath", {
        get: function () {
            return 'my';
        },
        enumerable: true,
        configurable: true
    });
    DxoMyComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'dxo-my',
                    template: '',
                    styles: [''],
                    providers: [nested_option_1.NestedOptionHost]
                },] },
    ];
    DxoMyComponent.ctorParameters = function () { return [
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.SkipSelf }, { type: core_1.Host },] },
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.Host },] },
    ]; };
    DxoMyComponent.propDecorators = {
        'x': [{ type: core_1.Input },],
        'y': [{ type: core_1.Input },],
    };
    return DxoMyComponent;
}(nested_option_2.NestedOption));
exports.DxoMyComponent = DxoMyComponent;
var DxoMyModule = (function () {
    function DxoMyModule() {
    }
    DxoMyModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [
                        DxoMyComponent
                    ],
                    exports: [
                        DxoMyComponent
                    ],
                },] },
    ];
    DxoMyModule.ctorParameters = function () { return []; };
    return DxoMyModule;
}());
exports.DxoMyModule = DxoMyModule;
//# sourceMappingURL=my.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme-angular/ui/nested/my.js
// module id = ../../../../devextreme-angular/ui/nested/my.js
// module chunks = 3